module.exports = __webpack_public_path__ + "img/academy-achieve.463d0f1c.png";